import React from "react";
import { CheckCircle2 } from "lucide-react";

export const ThankYouMessage: React.FC = () => (
  <div className="w-full flex flex-col items-center justify-center gap-3 sm:gap-4 animate-fade-in">
    <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-green-50 animate-scale-in">
      <CheckCircle2 className="w-8 h-8 sm:w-10 sm:h-10 text-green-600 animate-scale-in-delay" />
    </div>
    <div className="flex flex-col items-center gap-1 sm:gap-2">
      <h2 className="text-lg sm:text-xl font-bold font-editorial italic text-center text-[#10333B]">
        Thank you for your feedback!
      </h2>
      <p className="text-center text-xs sm:text-sm text-gray-600">Your input helps us improve</p>
    </div>
  </div>
);
